import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Icon from '../misc/Icons'
import { getItemPathSegments } from '../../utils/search/getItemPathSegments'

// Clickable root -> leaf breadcrumb shown in a result row's meta line. Each
// segment navigates to its pack/folder. stopPropagation on the segment keeps a
// click on the breadcrumb from also triggering the row's click/double-click.
function SearchResultsRowPath({ item, folders }) {
  const segments = getItemPathSegments(item, folders)
  if (!segments.length) return null
  const stop = (e) => { e.stopPropagation() }
  return (
    <span className='searchResultsRow-path'>
      {segments.map((seg, idx) => (
        <React.Fragment key={seg.id}>
          {idx > 0 && <Icon name='chevron-right' className='searchResultsRow-path-chevron' />}
          <Link
            to={seg.to}
            className='searchResultsRow-path-segment'
            onClick={stop}
            onMouseDown={stop}
          >
            {seg.label}
          </Link>
        </React.Fragment>
      ))}
    </span>
  )
}

function mapStateToProps(state) {
  return { folders: state.folders }
}

export default connect(mapStateToProps)(SearchResultsRowPath)
